import React from 'react'
import { ActivityIndicator, FlatList } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { useBrandLeads } from '@zet/feature-leads/api/leads/hooks/useBrandLeads'
import { LeadCard } from '@zet/feature-leads/components/leadCard'
import moment from 'moment'

const CustomerLead = ({
  route,
}: {
  route: {
    params: {
      customerPhoneNumber?: string
      customerId?: string
      leadsType?: string
    }
  }
}) => {
  const {
    data: leadsData,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    refetch,
  } = useBrandLeads(
    route?.params?.customerPhoneNumber ?? '',
    Number(route?.params?.customerId)
  )
  const leadCardList = leadsData?.pages?.map((page) => page?.leads).flat() || []

  const renderItem = ({ item }: any) => {
    return (
      <LeadCard
        isCustomerSpecific={true}
        key={item?.id}
        lastUpdateDate={moment.utc(item?.lastUpdatedDate).format('DD-MMM-YYYY')}
        nextUpdateDate={moment.utc(item?.nextUpdateDate).format('DD-MMM-YYYY')}
        name={item?.name}
        phoneNumber={item?.phoneNumber}
        status={item?.status}
        isBonusLead={item?.isBonusLead}
        subAgentName={item?.subAgentName}
        hasNotMoved={item?.hasNoUpdate}
        paymentStatus={item?.partnerTransaction?.[0].status ?? ''}
        rejectionReason={item?.rejectionReason}
        pendingDays={item?.expiryDays}
        isDelayedByBrand={item?.isReportDelayed}
        brandCommission={item?.brandCommission}
        commissionType={item?.commissionType}
        commission={item?.partnerTransaction?.[0]?.commission ?? ''}
        title={item?.applicationAsks?.[0]?.title ?? ''}
        description={item?.applicationAsks?.[0]?.description ?? ''}
        isReopenAllowed={item?.isReopenAllowed}
        isReopened={item?.isReopened}
        id={item?.id}
        partnerId={item?.partnerId}
        customerId={item?.customerId}
        eventName={'click_action'}
        eventPayload={{
          item_name: 'my_leads_lead_card',
          lead_id: item?.id,
          lead_status: item?.status,
          customer_id: item?.customerId,
          partner_id: item?.partnerId,
        }}
        isShareNewLink={item?.isShareNewLink}
        askCode={item?.applicationAsks?.[0]?.askCode}
        extraCommission={item?.extraCommission}
      />
    )
  }

  return (
    <Stack className="felx-1 bg-grays-30">
      <FlatList
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps="always"
        renderItem={renderItem}
        data={leadCardList}
        ListFooterComponent={
          isFetchingNextPage ? (
            <ActivityIndicator style={{ marginTop: 18 }} size={'large'} />
          ) : (
            <></>
          )
        }
        onEndReached={() => {
          if (!isFetching && hasNextPage) {
            fetchNextPage()
          }
        }}
        onRefresh={() => refetch()}
        refreshing={isFetching && !isFetchingNextPage}
        onEndReachedThreshold={0.6}
        showsHorizontalScrollIndicator={false}
      />
    </Stack>
  )
}

export { CustomerLead }
